module.exports = __webpack_public_path__ + "assets/img/drz.98d38215.png";